jQuery(function( $ ){
    
    var action="click";
    var speed="500";
    $('.question').click( function(){
        $(this).toggleClass("on");
         $('.question').not(this).removeClass('on');
        $(this).next('.toggle-desc').slideToggle(speed).siblings('.toggle-desc').slideUp();
     
	});

   $('.faq-toggle-btn').click( function(){
         $('.more-faq').toggle();
          if ($('.more-faq').is(':visible')) {
          $('.faq-toggle-btn').html('Show less')
          } else {
            $('.faq-toggle-btn').html('Show more')
          }
	});
});